import { createAction, props } from '@ngrx/store';
import type { Profile } from '../state/profile.state';
import type { UpdateUserRequest } from '../../../../core/service/identity/interface/identity.request';

export const UpdateProfileAction = createAction('[Profile] update', props<{ profile: UpdateUserRequest }>());
export const UpdateProfileActionSuccess = createAction('[Profile] update/success', props<{ profile: Profile }>());
export const UpdateProfileActionFail = createAction('[Profile] update/fail', props<{ error: any }>());
export const FetchProfile = createAction('[Profile] fetch user');
export const FetchProfileSuccess = createAction('[Profile] fetch user success', props<{ profile: Profile }>());
export const FetchProfileError = createAction('[Profile] fetch user fail', props<{ error: any }>());
